<template>
  <div class="banner-list-wrap" :class="[wrapperClass, { 'banner-display': banners.length > 0 }]">
    <PromoBannerNew v-for="banner in banners" :key="banner.id" :banner-data="banner" :wrapper-class="wrapperClass" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PromoBannerNew from '@/components/dashboard/ui/PromoBannerNew'

export default {
  name: 'PromoBannerList',
  components: {
    PromoBannerNew,
  },
  props: {
    wrapperClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      bannersForPage: 'banners/bannersForPage',
    }),
    banners() {
      return this.bannersForPage(this.$route.name) || []
    },
  },
  watch: {
    '$route.name': function () {
      this.fetchActiveBanners()
    },
  },
  created() {
    this.fetchActiveBanners()
  },
  methods: {
    ...mapActions({
      fetchActiveBanners: 'banners/fetchActiveBanners',
    }),
  },
}
</script>
<style lang="scss" scoped>
.banner-list-wrap {
  flex-direction: column;
  gap: 1rem;
  display: none;
  &.banner-display {
    display: flex;
  }
}
</style>